import { Banner, Button, Heading, LoadingIcon, OptionalElement, Paragraph } from '@lower-financial/core-components/src';
import { ReactElement } from 'react';
import styled from 'styled-components';

export const EmailBanner = ({
  heading, body, onClickHandler, isLoading = false, actionText,
}: {
  heading: string,
  body: string | ReactElement,
  onClickHandler?: () => void,
  isLoading?: boolean,
  actionText?: string
}) => (
  <BannerContainer>
    <Banner>
      <BannerHeading size={'xs'}>
        {heading}
      </BannerHeading>

      <Paragraph variant={'small'}>
        {body}
      </Paragraph>
      <OptionalElement show={onClickHandler !== undefined}>
        <ActionLink onClick={onClickHandler}>
          <OptionalElement show={isLoading}>
            <LoadingIconWrapper>
              <LoadingIcon
                spinnerHeight={'18px'}
              />
            </LoadingIconWrapper>
          </OptionalElement>
          <Button variant={'link'}>
            {actionText}
          </Button>
        </ActionLink>
      </OptionalElement>
    </Banner>
  </BannerContainer>
);

const BannerContainer = styled.div`
    max-width: 25rem;
    margin: auto 0 0 0;
  `;

const BannerHeading = styled(Heading)({
  marginBottom: 'var(--spacing-2)',
});

const LoadingIconWrapper = styled.div`
    height: 18px;
    margin-right: var(--spacing-2);
  `;

const ActionLink = styled.div`
    cursor: pointer;
    color: var(--primary);
    margin-top: var(--spacing-4);
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `;
